import { Chart, registerables } from "chart.js";
import { useEffect, useRef, useState } from "react";
import { FiRotateCcw, FiSearch } from "react-icons/fi";
import { TbArrowBackUp, TbBook2, TbBuildingWarehouse, TbCircleCheck, TbCircleX, TbPackage, TbPackageExport, TbPackageImport, TbScan, TbTruck, TbTruckDelivery, TbX } from "react-icons/tb";
import Skeleton from 'react-loading-skeleton';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, getDateAndTime, handleDateChange, initializeFilterData } from "../CommonComponents/CustomHooks";
import { AutoCompleteBoxNew, DateBox, FormButton } from "../CommonComponents/InputBox";
import { handleDownloadExcel } from "../CommonComponents/ExportData";
import { Table } from "../CommonComponents/Table";
import { CommonApiData } from "../CommonComponents/EnvConfig";
import { useDispatch } from 'react-redux';
import { setSubLoading } from "../../Redux/Services/AuthSlice";
//import { setSubLoading } from "../../Redux/Services/AuthSlice";

Chart.register(...registerables);

function useDonutChart(id, stats) {
    useEffect(() => {
        if (!stats) return;

        const el = document.getElementById(id);
        if (!el) return;

        const chart = new Chart(el, {
            type: "doughnut",
            data: {
                labels: ["Pickup", "In Scanned", "OFP", "Picked Up"],
                datasets: [{
                    data: [

                        Number(stats?.totalInScanned ?? 0),
                        Number(stats?.totalOFP ?? 0),
                        Number(stats?.totalPickedUp ?? 0),
                    ],
                    backgroundColor: ["#3b82f6", "#10b981", "#f59e0b", "#ef4444"],
                    borderWidth: 0,
                    hoverOffset: 4,
                }],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                cutout: "70%",
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        callbacks: {
                            label: c => ` ${c.label}: ${c.parsed}`,
                        },
                    },
                },
            },
        });

        return () => chart.destroy();
    }, [stats]); // ← stats change hone pe re-render
}
function useDonutChart2(id, stats) {
    useEffect(() => {
        if (!stats) return;

        const el = document.getElementById(id);
        if (!el) return;

        const chart = new Chart(el, {
            type: "doughnut",
            data: {
                labels: ["Booked", "In Transit", "In Facility", "OFD", "Delivered", "Undelivered", "RTO", "Cancelled"],
                datasets: [{
                    data: [

                        Number(stats?.totalInTransit ?? 0),
                        Number(stats?.totalInFacility ?? 0),
                        Number(stats?.totalOFD ?? 0),
                        Number(stats?.totalDelivered ?? 0),
                        Number(stats?.totalUnDelivered ?? 0),
                        Number(stats?.totalRTO ?? 0),
                        Number(stats?.totalCancelled ?? 0),
                    ],
                    backgroundColor: ["#3b82f6", "#10b981", "#f59e0b", "#8b5cf6", "#06b6d4", "#ef4444", "#f97316", "#6b7280"],
                    borderWidth: 0,
                    hoverOffset: 4,
                }],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                cutout: "70%",
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        callbacks: { label: c => ` ${c.label}: ${c.parsed}` },
                    },
                },
            },
        });

        return () => chart.destroy();
    }, [stats]);
}
function useLineChart(id) {
    useEffect(() => {
        const el = document.getElementById(id);
        if (!el) return;
        const chart = new Chart(el, {
            type: "line",
            data: {
                labels: ["Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar", "Apr"],
                datasets: [
                    { label: "Revenue", data: [4.2, 4.8, 4.1, 5.3, 5.7, 6.4, 4.9, 5.2, 5.8, 6.1], borderColor: "#4179a5", backgroundColor: "rgba(65,121,165,0.08)", fill: true, tension: 0.4, pointRadius: 3, pointBackgroundColor: "#4179a5", borderWidth: 2 },
                    { label: "Cost", data: [2.9, 3.2, 3.0, 3.6, 3.8, 4.1, 3.3, 3.4, 3.7, 3.9], borderColor: "#d97706", backgroundColor: "rgba(217,119,6,0.06)", fill: true, tension: 0.4, pointRadius: 3, pointBackgroundColor: "#d97706", borderWidth: 2 },
                ],
            },
            options: {
                responsive: true, maintainAspectRatio: false,
                plugins: { legend: { display: false } },
                scales: {
                    x: { grid: { display: false }, ticks: { color: "#9ca3af", font: { size: 10 } } },
                    y: { grid: { color: "rgba(0,0,0,0.05)" }, ticks: { color: "#9ca3af", font: { size: 10 }, callback: v => "$" + v + "M" } },
                },
            },
        });
        return () => chart.destroy();
    }, []);
}

// ─── Components ───────────────────────────────────────────────────────────────

function KPICard({ label, value, sub, subColor, accent, icon: Icon, iconBg, iconColor, onClick }) {
    return (
        <div className="relative bg-white border border-gray-100 rounded-xl p-3 overflow-hidden cursor-pointer hover:shadow-md transition-shadow"
            onClick={onClick}>
            <div className={`absolute top-0 left-0  w-[3px] h-full ${accent}`} />
            <div className="flex items-center justify-between pl-1">
                <div>
                    <p className="text-[10px] font-medium text-gray-400 uppercase tracking-widest mb-1">{label}</p>
                    <p className="text-2xl font-bold text-gray-800 leading-none">{value ?? "0"}</p>
                    {sub && <p className={`text-[11px] mt-2 ${subColor}`}>{sub}</p>}
                </div>
                {Icon && (
                    <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${iconBg}`}>
                        <Icon size={20} className={iconColor} />
                    </div>
                )}
            </div>
        </div>
    );
}
function RouteBar({ name, mode, pct, count }) {
    // Tailwind can't generate dynamic widths at runtime, so we use a wrapper trick
    const widthMap = { 88: "w-[88%]", 74: "w-[74%]", 61: "w-[61%]", 48: "w-[48%]", 37: "w-[37%]" };
    return (
        <div className="flex items-center gap-3 py-2 border-b border-gray-100 last:border-0">
            <div className="w-32 shrink-0">
                <p className="text-xs font-medium text-gray-700">{name}</p>
                <p className="text-[10px] text-gray-400">{mode}</p>
            </div>
            <div className="flex-1 h-1.5 bg-gray-100 rounded-full overflow-hidden">
                <div className={`h-full bg-brand rounded-full ${widthMap[pct]}`} />
            </div>
            <span className="text-[11px] text-gray-400 w-8 text-right shrink-0">{count}</span>
        </div>
    );
}

export default function Dashboard() {
    //const [subLoading, setSubLoading] = useState(false);
    const [stats, setStats] = useState(null);
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [showModalBox, setShowModalBox] = useState(false)
    const [tableData, setTableData] = useState([])
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();
    const [selectedCardDetails, setSelectedCardDetails] = useState("")

    const [exportData, setExportData] = useState({
        CallType: ""
    });
    const inputrefs = useRef([])
    const initialFormData = {
        fromDate: getDateAndTime(7).date,
        toDate: getDateAndTime().date,
    }
    const [formData, setFormData] = useState(initialFormData);
    const extraPayload = {
        ...filterData,
        ...formData,
        "loginUserBCode": CommonApiData().loginUserBCode,
    }

    useDonutChart("donutChart", stats);
    useDonutChart2("donutChart2", stats);
    useLineChart("revChart");

    const getDashboardData = async () => {
        try {
            await dispatch(setSubLoading(true));
            setSubLoading(true);
            let GetData = {
                Type: "S",
                ...formData,
            };
            let data = await ApiCall('/api/Dashboard/GetDashboardCount', GetData);
            if (data?.status === 'EXPIRED') {
                NotificationSound(data.status, data.message)
                return;
            }
            setStats(data?.data);
        } catch (error) {
            console.error("Dashboard Count Error:", error);
        } finally {
            setSubLoading(false);
            await dispatch(setSubLoading(false));
        }
    };

    const handleCardClick = async (CurrentPage = currentPageNo, callType, dashboardName, freshSortConfig) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        const data = {
            Type: "S",
            ...formData,
            ...filterData,
            CallType: callType || "",
            PageIndex: `${PageIndex}`,
            ...(freshSortConfig || sortConfig),
        };
        setExportData(prev => ({
            ...prev,
            CallType: callType || ""
        }));
        let res = await ApiCall(`/api/Dashboard/GetDashboardGridDetails`, data)
        if (res.Status === 'SUCCESS') {
            setTableData(res);
            setSelectedCardDetails(dashboardName)
            console.log(selectedCardDetails)
            setShowModalBox(true)
        } else if (res.Status === 'ERROR') {
            setTableData([]);
            setSelectedCardDetails("")
        }
        if (res.Status === 'EXPIRED') {
            await NotificationSound(res.Status, res.Message, res.focus, inputrefs);
        }
    }

    const handleChange1 = (event, value) => {
        handleCardClick(value, exportData.CallType, selectedCardDetails);
    };


    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';
        if (sortConfig?.SortColumn === SortColumn && sortConfig?.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        const newSortConfig = { SortColumn, SortOrder };
        setSortConfig(newSortConfig);

        handleCardClick(currentPageNo, exportData.CallType, selectedCardDetails, newSortConfig);
    };
    const handleModalDocShowClose = async () => {
        await setShowModalBox(false)
        await setSelectedCardDetails("")
    };
    const handleReset = async () => {
        await setFormData(initialFormData)
        inputrefs.current['txtFromdate'].focus()
        getDashboardData()
    }

    useEffect(() => {
        inputrefs.current['txtFromdate'].focus()
        document.title = 'Dashboard'
        getDashboardData();
    }, []);

    return (
        <div className="">
            <div className="bg-brand rounded-t-2xl p-2  flex items-center justify-between" style={{ backgroundColor: "var(--theme-color)" }} >
                <div>
                    <h1 className="text-white text-2xl font-bold tracking-tight">Dashboard</h1>

                </div>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3 w-full mt-2 p-2">

                <DateBox
                    inputrefs={inputrefs}
                    label="From Date"
                    id='txtFromdate'
                    maxDate={new Date()}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            inputrefs.current['txtTodate'].focus();
                        }
                    }}
                    selected={formData.fromDate === '' ? '' : new Date(formData.fromDate)}
                    onChange={(e) => handleDateChange(e, setFormData, formData, 'fromDate')}
                />

                <DateBox
                    inputrefs={inputrefs}
                    label="To Date"
                    id='txtTodate'
                    maxDate={new Date()}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            inputrefs.current['btn'].focus();
                        }
                    }}
                    selected={formData.toDate === '' ? '' : new Date(formData.toDate)}
                    onChange={(e) => handleDateChange(e, setFormData, formData, 'toDate')}
                />

                <div className="flex items-end gap-2 mt-3">

                    <button
                        ref={(el) => inputrefs.current['btn'] = el}
                        id="btn"
                        onClick={getDashboardData}
                        className="h-7 w-8 p-0 text-white rounded-md flex items-center justify-center transition bg-green-500 hover:bg-green-600"
                        title="Search"
                    >
                        <FiSearch className="text-lg" />
                    </button>

                    <button
                        onClick={handleReset}
                        className="h-7 w-8 p-0 text-white rounded-md flex items-center justify-center transition bg-red-500 hover:bg-red-600"
                        title="Reset"
                    >
                        <FiRotateCcw className="text-lg" />
                    </button>

                </div>

            </div>

            {/* Dashboard Body */}
            <div className="bg-gray-50 rounded-b-2xl p-3 pt-1 space-y-4 mt-3">

                {/* Pickup KPIs */}
                <div className="mb-3">
                    <p className="text-xs font-semibold text-gray-500 uppercase tracking-widest mb-2 px-1">Pickup</p>

                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">

                        {isLoading ? (
                            [...Array(4)].map((_, i) => (
                                <div key={i} className="p-4 border rounded-xl bg-white shadow-sm">
                                    <Skeleton height={15} width={80} />
                                    <Skeleton height={25} width={60} style={{ marginTop: 10 }} />
                                </div>
                            ))
                        ) : (
                            <>
                                <KPICard label="Pickup" value={stats?.totalPickUp} accent="bg-blue-500" icon={TbTruckDelivery} iconBg="bg-blue-100" iconColor="text-blue-600" onClick={() => handleCardClick(currentPageNo, "GetTotalPickup", "Pickup")} />
                                
                                <KPICard label="OFP" value={stats?.totalOFP} accent="bg-amber-500" icon={TbPackageExport} iconBg="bg-amber-50" iconColor="text-amber-500" onClick={() => handleCardClick(currentPageNo, "GetTotalOFP", "OFP")} />
                                <KPICard label="Picked Up" value={stats?.totalPickedUp} accent="bg-red-500" icon={TbPackageImport} iconBg="bg-red-50" iconColor="text-red-500" onClick={() => handleCardClick(currentPageNo, "GetTotalPickedUp", "Picked Up")} />
                            </>
                        )}

                    </div>
                </div>

                {/* Booking KPIs */}
                <div>
                    <p className="text-xs font-semibold text-gray-500 uppercase tracking-widest mb-2 px-1">Booking</p>

                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">

                        {isLoading ? (
                            [...Array(8)].map((_, i) => (
                                <div key={i} className="p-4 border rounded-xl bg-white shadow-sm">
                                    <Skeleton height={15} width={80} />
                                    <Skeleton height={25} width={60} style={{ marginTop: 10 }} />
                                </div>
                            ))
                        ) : (
                                <>
                                    <KPICard label="In Scanned" value={stats?.totalInScanned} accent="bg-emerald-500" icon={TbScan} iconBg="bg-emerald-50" iconColor="text-emerald-500" onClick={() => handleCardClick(currentPageNo, "GetTotalInScanned", "In Scanned")} />
                                <KPICard label="Booked" value={stats?.totalBooked} accent="bg-blue-500" icon={TbBook2} iconBg="bg-blue-100" iconColor="text-blue-600" onClick={() => handleCardClick(currentPageNo, "GetTotalBooked", "Booked")} />
                                <KPICard label="In Transit" value={stats?.totalInTransit} accent="bg-indigo-500" icon={TbTruck} iconBg="border-indigo-100" iconColor="text-indigo-600" onClick={() => handleCardClick(currentPageNo, "GetTotalInTransit", "In Transit")} />
                                <KPICard label="In Facility" value={stats?.totalInFacility} accent="bg-amber-500" icon={TbBuildingWarehouse} iconBg="bg-amber-50" iconColor="text-amber-600" onClick={() => handleCardClick(currentPageNo, "GetTotalInFacility", "In Facility")} />
                                <KPICard label="OFD" value={stats?.totalOFD} accent="bg-violet-500" icon={TbPackage} iconBg="border-violet-100" iconColor="text-violet-600" onClick={() => handleCardClick(currentPageNo, "GetTotalOFD", "OFD")} />
                                <KPICard label="Delivered" value={stats?.totalDelivered} accent="bg-green-500" icon={TbCircleCheck} iconBg="border-green-100" iconColor="text-green-600" onClick={() => handleCardClick(currentPageNo, "GetTotalDELIVERED", "Delivered")} />
                                <KPICard label="UnDelivered" value={stats?.totalUnDelivered} accent="bg-red-500" icon={TbCircleX} iconBg="bg-red-100" iconColor="text-red-500" onClick={() => handleCardClick(currentPageNo, "GetTotalUNDELIVERED", "UnDelivered")} />
                                <KPICard label="RTO" value={stats?.totalRTO} accent="bg-gray-500" icon={TbArrowBackUp} iconBg="bg-gray-100" iconColor="text-gray-500" onClick={() => handleCardClick(currentPageNo, "GetTotalRTO", "RTO")} />
                                <KPICard label="Cancelled" value={stats?.totalCancelled} accent="bg-orange-500" icon={TbX} iconBg="bg-orange-100" iconColor="text-orange-500" onClick={() => handleCardClick(currentPageNo, "GetTotalCancelled", "Cancelled")} />
                            </>
                        )}

                    </div>
                </div>
                {/* Charts Row 1 — Volume + Donut */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
                    <div className="bg-white border border-gray-100 rounded-xl p-3">
                        <div className="flex items-center justify-between mb-3">
                            <p className="text-sm font-semibold text-gray-700">Pickup Status</p>
                            <span className="text-[11px] text-blue-500">Live</span>
                        </div>

                        {/* Donut with center total */}
                        <div className="relative h-36">
                            {isLoading ? (
                                <Skeleton height="100%" />
                            ) : (
                                <canvas id="donutChart" />
                            )}
                            <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
                                {isLoading ? (
                                    <Skeleton width={60} />
                                ) : (
                                    <p className="text-xl font-bold text-gray-800">
                                        {
                                            Number(stats?.totalInScanned ?? 0) +
                                            Number(stats?.totalOFP ?? 0) +
                                            Number(stats?.totalPickedUp ?? 0)}
                                    </p>
                                )}
                                <p className="text-[10px] text-gray-400 uppercase tracking-widest">Total</p>
                            </div>
                        </div>

                        {/* Dynamic Legend */}
                        <div className="flex flex-wrap justify-center gap-x-3 px-5 gap-y-1 mt-3 text-[11px] text-gray-600">
                            {[
                                { colorClass: "bg-emerald-500", label: "In Scanned", value: stats?.totalInScanned },
                                { colorClass: "bg-amber-500", label: "OFP", value: stats?.totalOFP },
                                { colorClass: "bg-red-500", label: "Picked Up", value: stats?.totalPickedUp },
                            ].map(d => (
                                <span key={d.label} className="flex items-center gap-1 whitespace-nowrap">
                                    <span className={`w-2 h-2 rounded-sm ${d.colorClass}`} />

                                    <span>{d.label}:</span>

                                    <strong className="text-gray-800">
                                        {d.value ?? "0"}
                                    </strong>
                                </span>
                            ))}
                        </div>
                    </div>

                    <div className="bg-white border border-gray-100 rounded-xl p-3">
                        <div className="flex items-center justify-between mb-3">
                            <p className="text-sm font-semibold text-gray-700">Booking Status</p>
                            <span className="text-[11px] text-blue-500">Live</span>
                        </div>

                        {/* Donut with center total */}
                        <div className="relative h-36">
                            {isLoading ? (
                                <Skeleton height="100%" />
                            ) : (
                                <canvas id="donutChart2" />
                            )}
                            <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
                                {isLoading ? (
                                    <Skeleton width={60} />
                                ) : (
                                    <p className="text-xl font-bold text-gray-800">
                                        {
                                            Number(stats?.totalInTransit ?? 0) +
                                            Number(stats?.totalInFacility ?? 0) +
                                            Number(stats?.totalOFD ?? 0) +
                                            Number(stats?.totalDelivered ?? 0) +
                                            Number(stats?.totalUnDelivered ?? 0) +
                                            Number(stats?.totalRTO ?? 0) +
                                            Number(stats?.totalCancelled ?? 0)}
                                    </p>
                                )}
                                <p className="text-[10px] text-gray-400 uppercase tracking-widest">Total</p>
                            </div>
                        </div>

                        {/* Dynamic Legend */}
                        <div className="flex flex-wrap justify-center gap-x-3 px-5 gap-y-1 mt-3 text-[11px] text-gray-600">
                            {[
                                { colorClass: "bg-emerald-500", label: "In Transit", value: stats?.totalInTransit },
                                { colorClass: "bg-amber-500", label: "In Facility", value: stats?.totalInFacility },
                                { colorClass: "bg-violet-500", label: "OFD", value: stats?.totalOFD },
                                { colorClass: "bg-cyan-500", label: "Delivered", value: stats?.totalDelivered },
                                { colorClass: "bg-red-500", label: "Undelivered", value: stats?.totalUnDelivered },
                                { colorClass: "bg-orange-500", label: "RTO", value: stats?.totalRTO },
                                { colorClass: "bg-gray-500", label: "Cancelled", value: stats?.totalCancelled },
                            ].map(d => (
                                <span key={d.label} className="flex items-center gap-1 whitespace-nowrap">
                                    <span className={`w-2 h-2 rounded-sm ${d.colorClass}`} />

                                    <span>{d.label}:</span>

                                    <strong className="text-gray-800">
                                        {d.value ?? "0"}
                                    </strong>
                                </span>
                            ))}
                        </div>
                    </div>

                </div>
                <Dialog
                    open={showModalBox}
                    onClose={handleModalDocShowClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    maxWidth={false}
                    sx={{
                        "& .MuiDialog-container": {
                            "& .MuiPaper-root": {
                                width: "100%",
                                maxWidth: "1000px",
                            }

                        },
                        "& .css-hz1bth-MuiDialog-container": {
                            alignItems: 'center'
                        },
                        "& .MuiPaper-root": {
                            width: '95vw',
                            maxWidth: '1000px',
                            borderRadius: '8px',
                        },
                    }}>

                    <DialogTitle
                        id="alert-dialog-title"
                        className="p-3 border-b flex justify-between items-center"
                    >
                        <div style={{ fontWeight: 500 }}> {selectedCardDetails ? `${selectedCardDetails} Details` : "Dashboard Details"} </div>
                        <div className="flex items-center gap-3">
                            <FormButton
                                divclassname="items-end"
                                id={'btnSub'}
                                inputrefs={inputrefs}
                                handleExport={async () => {
                                    const payload = {

                                        ...extraPayload,
                                        ...exportData,
                                    };
                                    setSubLoading(true)
                                    await handleDownloadExcel(
                                        `/api/Dashboard/GetDashboardGridDetails`,
                                        payload,
                                        selectedCardDetails ? `${selectedCardDetails} Details` : "Dashboard Details"
                                    )
                                    setSubLoading(false)
                                }}
                                save={false}
                                search={false}
                                Export={true}
                                Reset={false}
                            />
                            <i
                                className="fa-solid fa-xmark cursor-pointer text-[16px] p-[6px] rounded-full bg-gray-100 text-gray-500 inline-flex items-center justify-center w-[30px] h-[30px] transition-colors duration-200 hover:bg-gray-200"
                                onClick={handleModalDocShowClose}
                                title="Close"
                            />
                        </div>
                    </DialogTitle>


                    <DialogContent className='m-2 p-2' >

                        <Table
                            loading={isLoading}
                            PageName={'LeadDashboard'}
                            handleFilter={() => {
                                handleCardClick(currentPageNo, exportData.CallType, selectedCardDetails)
                                setFilterData({ ...filterData })
                            }}
                            filterData={filterData}
                            tableData={tableData}
                            setFilterData={setFilterData}
                            currentPageNo={currentPageNo}
                            handleChange1={handleChange1}
                            handleSorting={handleSorting}
                            sortConfig={sortConfig}
                            Filter={false}
                            onlyFilterPage={true}
                        />
                    </DialogContent>
                </Dialog>
            </div>
        </div>
    );
}